//redusers/meals.js
import { createReducer } from "@reduxjs/toolkit";
const initialState = {
    isLoading: false,
    isLoadingMeal: false,
    mealData: null,
    isLoadingUpdate: false, 
    isLoadingDelete: false,
    isLoadingCreate: false,

  };

  const featuredMealsReducer = createReducer(initialState, (builder) => {
    builder
      .addCase("get_all_FeaturedMeals_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_all_FeaturedMeals_success", (state,action) => {
        state.isLoading = false;
        state.Allmeals = action.payload.meals;
        state.pagination = action.payload.pagination;
        state.totalFeaturedMeals=action.payload.totalFeaturedMeals
        state.totalfeaturedMeals=action.payload.totalfeaturedMeals
      })
      .addCase("get_all_FeaturedMeals_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      })
      .addCase("get_Fillter_FeaturedMeals_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_Fillter_FeaturedMeals_success", (state,action) => {
        state.isLoading = false;
        state.Filltermeals = action.payload.meals;
        state.pagination = action.payload.pagination;
      })
      .addCase("get_Fillter_meals_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      })
      .addCase("get_FeaturedMeal_request", (state) => {
        state.isLoadingMeal = true;
      })
      .addCase("get_FeaturedMeal_success", (state,action) => {
        state.isLoadingMeal = false;
        state.mealData = action.payload;
      })
      .addCase("get_FeaturedMeal_error", (state,action) => {
        state.isLoadingMeal = false;
        state.err = action.payload;
      })
      .addCase("create_FeaturedMeal_request", (state) => {
        state.isLoadingCreate = true;
      })
      .addCase("create_FeaturedMeal_success", (state,action) => {
        state.isLoadingCreate = false;
        state.Createdmeal = action.payload;

      })
      .addCase("create_FeaturedMeal_error", (state,action) => {
        state.isLoadingCreate = false;
        state.errCreate = action.payload;
      })
      .addCase("update_FeaturedMeal_request", (state) => {
        state.isLoadingUpdate = true;
      })
      .addCase("update_FeaturedMeal_success", (state,action) => {
        state.isLoadingUpdate = false;
        state.Updatedmeal = action.payload;
      })
      .addCase("update_meal_error", (state,action) => {
        state.isLoadingUpdate = false;
        state.err = action.payload;
      })

      .addCase("get_FillterWithSort_FeaturedMeals_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_FillterWithSort_FeaturedMeals_success", (state,action) => {
        state.isLoading = false;
        state.FilltermealsWithSort = action.payload.meals;
        state.FilterpaginationWithSort = action.payload.pagination;
      })
      .addCase("get_FillterWithSort_FeaturedMeals_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      })
      .addCase("delete_FeaturedMeal_request", (state) => {
        state.isLoadingDelete = true;
      })
      .addCase("delete_FeaturedMeal_success", (state,action) => {
        state.isLoadingDelete = false;
        state.DeleteMessage = action.payload;
      })
      .addCase("delete_FeaturedMeal_error", (state,action) => {
        state.isLoadingDelete = false;
        state.err = action.payload;
      })
      .addCase("clear_error", (state) => {
        state.err = null;
        state.DeleteMessage = null;
        state.Updatedmeal = null;
        state.isLoadingDelete = false;
       state.isLoadingUpdate = false;
       state.isLoadingCreate = false;
       state.errCreate=false;
      

      });
      
  });

  
  export default featuredMealsReducer;